import React, { useEffect, useState, useCallback, memo } from "react";
import { motion } from "framer-motion";

import boy from "assets/layout_img/boy.svg";
import vector1 from "assets/layout_img/vector2.svg";
import vector2 from "assets/layout_img/vector1.svg";
import medal from "assets/layout_img/medal.svg";

import "styles/public.css";

const Card = memo(({ icon, label, value, className = "" }) => (
  <motion.div
    className={`card animated-card ${className}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ duration: 0.7, ease: "easeOut" }}
  >
    {icon && <img src={icon} alt="" className="card_icon" loading="lazy" />}
    <p className="card_label">{label}</p>
    <h3 className="card_value">{value}</h3>
  </motion.div>
));
Card.displayName = "HomeStatCard";

const API_URL =
  "https://algoritm-api-edu.uz/api/public/MainPageUi/GetAllBanners";

const HomeSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchBanners = useCallback(async () => {
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search: "",
          sortBy: "",
          orderType: "",
          pageSize: 0,
          page: 0,
          startDate: null,
          endDate: null,
        }),
      });

      if (!response.ok) throw new Error("Network error");
      // const data = await response.json(); // agar kerak bo'lsa ishlatiladi
      // console.log("Bannerlar:", data?.rows || []);
    } catch (err) {
      // Xatolikni jim yutib yuboramiz — foydalanuvchiga ta'sir qilmaydi
    } finally {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchBanners();
  }, [fetchBanners]);

  // Animatsiyani faqat komponent birinchi marta ko'rinishi bilan ishga tushiramiz
  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => {
        document.querySelectorAll(".animated-card").forEach((card) => {
          card.classList.add("show");
        });
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isLoaded]);

  return (
    <section id="home" className="home">
      <div className="home_container">
        <img src={vector1} alt="" className="vector" loading="lazy" />
        <img src={vector2} alt="" className="vector2" loading="lazy" />

        <div className="container_flex">
          <p className="mini_title">
            <span>//</span> Markazimiz shiori va maqsadi
          </p>

          <motion.h1
            className="main_title typewriter"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.3 }}
          >
            {isLoaded
              ? "O‘quvchini emas, kelajakni tarbiyalaymiz"
              : "Yuklanmoqda..."}
          </motion.h1>

          <motion.p
            className="sub_text fade_paragraph"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.6 }}
          >
            {isLoaded
              ? "Bizning maqsad — har bir yoshning salohiyatini ochish, zamonaviy ta’lim va amaliy tajriba orqali kelajagini mustahkamlash."
              : ""}
          </motion.p>
        </div>

        <div className="container_img">
          <Card label="Tajriba" value="4 yil" className="card1" />
          <motion.img
            src={boy}
            alt="Talaba illustratsiyasi"
            className="home_img"
            loading="lazy"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          />
          <Card
            icon={medal}
            label="O'quvchilar soni"
            value="2000 + o'quvchilar"
            className="card2"
          />
        </div>
      </div>
    </section>
  );
};

export default memo(HomeSection);
